module.exports = __webpack_public_path__ + "static/mckinsey-img-92fa7ed6688936fb19062cc8be8340b8.svg";